import React from 'react';

import { HGF2 } from '../../components/hgf2';
import { HGFLegacy } from '../../components/hgf-legacy';
import { Layout } from '../../components/layout';
import SEO from '../../components/seo';
import { isLegacyHgf } from '../../model/hgf';

interface Props {
  location: { hash: string };
}

// Version-aware entry point. Legacy hashes (e.g. `#c000p000…`) keep rendering
// the original HGF so historical/bookmarked links stay valid; everything else
// (including no hash) renders the current HGF2.
//
// The URL hash only exists in the browser, so the static build always renders
// the HGF2 default. To avoid a hydration mismatch we render *both* versions and
// only toggle their visibility once mounted on the client — the initial markup
// therefore matches the server on both branches.
export default function HGF({ location }: Props): JSX.Element {
  const [legacy, setLegacy] = React.useState(false);
  React.useEffect(() => {
    setLegacy(isLegacyHgf(location.hash.substring(1)));
  }, [location.hash]);
  return (
    <Layout>
      <SEO title="nerdgeschoss Human Growth Framework" />
      <div hidden={legacy}>
        <HGF2 location={location} />
      </div>
      <div hidden={!legacy}>
        <HGFLegacy location={location} />
      </div>
    </Layout>
  );
}
